
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 .5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5V2H3c-1.125 0-2 .906-2 2v10c0 1.125.875 2 2 2h2v-1H3c-.563 0-1-.438-1-1V6h12v1h1V4c0-1.094-.906-2-2-2h-1V.5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5V2H5V.5zM3 3h10c.531 0 1 .469 1 1v1H2V4c0-.531.438-1 1-1z","fill":"#000"}}),_c('path',{attrs:{"d":"M7 8h8c.531 0 1 .469 1 1v6c0 .563-.469 1-1 1H7c-.563 0-1-.438-1-1V9c0-.531.438-1 1-1zm8 1.84V9H7v.84l3.75 1.853a.59.59 0 00.25.063.581.581 0 00.219-.063L15 9.841zm0 1.126l-3.313 1.602a1.424 1.424 0 01-.687.188c-.25 0-.5-.063-.719-.188L7 10.966V15h8v-4.034z","fill":"#000"}})])
          )
        }
      }
    